import script from "./table-cell-widget-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./table-cell-widget-ly.vue?vue&type=script&setup=true&lang=js"

import "./table-cell-widget-ly.vue?vue&type=style&index=0&id=177f28aa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-177f28aa"]])

export default __exports__